exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".matchingGoods .ivu-tabs-nav{float:right}", ""]);

// exports
